import { css } from '@linaria/core';
import { styled } from '@linaria/react';
import { theming } from 'styles/utils/core';
import { SpinnerProps } from './types';
export const Container = /*#__PURE__*/styled("div")({
  name: "Container",
  class: "omponents__Spinner__Spinner_styles_tsx-Container-c16kim38"
});
export const BlobWrapper = /*#__PURE__*/styled("div")({
  name: "BlobWrapper",
  class: "omponents__Spinner__Spinner_styles_tsx-BlobWrapper-b8wlnna"
});
export const Blob = /*#__PURE__*/styled("div")({
  name: "Blob",
  class: "omponents__Spinner__Spinner_styles_tsx-Blob-bgtgzic",
  vars: {
    "bgtgzic-0": [({
      size
    }) => size, "rem"],
    "bgtgzic-2": [({
      size
    }) => -size / 2, "rem"]
  }
});
export const headingClassName = "omponents__Spinner__Spinner_styles_tsx-headingClassName-h19pafyw";
export const descriptionClassName = "omponents__Spinner__Spinner_styles_tsx-descriptionClassName-d1dy53z9";

require("./Spinner.styles.linaria.module.css!=!../../node_modules/@linaria/webpack-loader/node_modules/@linaria/webpack5-loader/lib/outputCssLoader.js!./Spinner.styles.tsx");